import React from "react";
import { Layout, Row, Col, Typography, Space } from "antd";
import {
  FacebookOutlined,
  InstagramOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";

const { Footer } = Layout;
const { Title, Paragraph } = Typography;

function MainFooter() {
  return (
    <Footer
      style={{
        background: "#111111",
        color: "#fff",
        padding: "64px 24px",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <Row gutter={[32, 32]}>

          {/* LOGO + ATENDIMENTO */}
          <Col xs={24} md={8}>
            <Title level={3} style={{ color: "#d4b483", marginTop: 0 }}>
              Gold Service
            </Title>

            <Title level={5} style={{ color: "#d4b483", marginTop: 24 }}>
              Atendimento
            </Title>

            <Paragraph style={{ color: "#ffffffd9", marginBottom: 6 }}>
              SEGUNDA-FEIRA A QUINTA-FEIRA
            </Paragraph>
            <Paragraph style={{ color: "#ffffffd9", marginBottom: 6 }}>
              07H30 | 17H30
            </Paragraph>
            <Paragraph style={{ color: "#ffffffd9" }}>
              SEXTA-FEIRA 07H30 | 16H30
            </Paragraph>
          </Col>

          {/* LINKS */}
          <Col xs={24} md={8}>
            <Title level={5} style={{ color: "#d4b483" }}>
              Gold Service
            </Title>

            <Space direction="vertical" size={8}>
              <a style={{ color: "#ffffffd9" }}>Sobre</a>
              <a style={{ color: "#ffffffd9" }}>Serviços</a>
              <a style={{ color: "#ffffffd9" }}>Tecnologia</a>
              <a style={{ color: "#ffffffd9" }}>Meio Ambiente</a>
              <a style={{ color: "#ffffffd9" }}>Fac</a>
              <a style={{ color: "#ffffffd9" }}>Contato</a>
              <a style={{ color: "#ffffffd9" }}>Acabamento</a>
            </Space>
          </Col>

          {/* CONTATO + REDES */}
          <Col xs={24} md={8}>
            <Paragraph style={{ color: "#ffffffd9", fontSize: 15 }}>
              Qualidade, agilidade, economia e curto prazo de atendimento dos
              pedidos.
            </Paragraph>

            {/* REDES */}
            <Space size={16} style={{ margin: "16px 0" }}>
              <div style={iconStyle}>
                <FacebookOutlined />
              </div>
              <div style={iconStyle}>
                <InstagramOutlined />
              </div>
              <div style={iconStyle}>
                <YoutubeOutlined />
              </div>
            </Space>

            {/* EMAILS */}
            <Paragraph style={textStrong}>
              comercial@goldservicerm.com.br
            </Paragraph>
            <Paragraph style={textStrong}>
              contato@goldservicerm.com.br
            </Paragraph>
            <Paragraph style={textStrong}>
              financeiro@goldservicerm.com.br
            </Paragraph>

            {/* TELEFONES */}
            {/* <Paragraph style={textStrong}>
              (11) 4555-4097 Fixo
            </Paragraph> */}
            <Paragraph style={textStrong}>
              (11) 99606-4416 Comercial
            </Paragraph>
            <Paragraph style={textStrong}>
              (11) 97584-9447 Atendimento
            </Paragraph>

            <Paragraph style={textStrong}>
              (11) | 99590-9929 (Financeiro)
            </Paragraph>
          </Col>
        </Row>
      </div>
    </Footer>
  );
}

const iconStyle = {
  width: 44,
  height: 44,
  borderRadius: 10,
  background: "#d4b483",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#111",
  fontSize: 20,
  cursor: "pointer",
};

const textStrong = {
  color: "#d4b483",
  marginBottom: 4,
  fontWeight: 500,
};

export default MainFooter;